import {
  FlattenedFilterState,
  RailsNestedFacetQuery,
} from '~/typings/services/rails/facets';
import { ApiPaginatedResponse, fetcher, makeFetcher } from 'fetcher-session';
import {
  RailsSavedSearch,
  RailsSavedSearchFrequency,
} from '~/typings/services/rails/savedSearch';

export const fetchSavedSearches = makeFetcher<
  ApiPaginatedResponse<RailsSavedSearch[]>
>((page?: number, type?: 'follow' | 'general') => [
  ({ uuid }) => `/v1/users/${uuid}/saved_searches`,
  {
    dataOnly: false,
    params: {
      page,
      type,
      page_size: 3,
    },
  },
]);

export const fetchSavedSearchById = makeFetcher<RailsSavedSearch, [id: number]>(
  (id: number) =>
    ({ uuid }) =>
      `/v1/users/${uuid}/saved_searches/${id}`,
);

export const updateSavedSearch = (
  id: number,
  name: string,
  frequency: RailsSavedSearchFrequency,
) =>
  fetcher<never>(({ uuid }) => `/v1/users/${uuid}/saved_searches/${id}`, {
    method: 'put',
    body: {
      saved_search: {
        name,
        frequency,
      },
    },
  });

export const deleteSavedSearch = (id: number) =>
  fetcher<never>(({ uuid }) => `/v1/users/${uuid}/saved_searches/${id}`, {
    method: 'delete',
  });

export const createSavedSearch = (
  name: string,
  query: RailsNestedFacetQuery | FlattenedFilterState,
  frequency = 'daily',
) =>
  fetcher<RailsSavedSearch>(({ uuid }) => `/v1/users/${uuid}/saved_searches`, {
    body: {
      name,
      query,
      frequency,
    },
    method: 'post',
  });
